import axios from "api/axios"
import { APIResponse, Config, ConfigWithURLParams } from "api/types"
import { formatErrorResponse, formatSuccessResponse } from "api/utils"

import {
  ProductDetails,
  RuleExecutionDetails,
  SubscriptionDetails,
} from "./types"
import { urls } from "./urls"

export default {
  retrieveSubscription: async ({
    params,
  }: Config): Promise<APIResponse<SubscriptionDetails>> => {
    try {
      const res = await axios.get(urls.subscription.retrieve(), { params })
      return formatSuccessResponse(res)
    } catch (e) {
      throw formatErrorResponse(e)
    }
  },
  cancelSubscription: async ({
    data,
    urlParams,
  }: ConfigWithURLParams<"userId">) => {
    try {
      const res = await axios.post(
        urls.subscription.cancel(urlParams.userId.toString()),
        data
      )
      return formatSuccessResponse(res)
    } catch (e) {
      throw formatErrorResponse(e)
    }
  },
  retrieveProductGroup: async ({
    data,
    urlParams,
  }: ConfigWithURLParams<"slug">): Promise<ProductDetails> => {
    // This API does not require authentication
    try {
      const res = await axios.post(
        urls.subscription.productGroup(urlParams.slug.toString()),
        data,
        {
          headers: {
            platform: "suraasa-web",
            Authorization: null,
          },
        }
      )
      return formatSuccessResponse(res)
    } catch (e) {
      throw formatErrorResponse(e)
    }
  },
  startFreeTrial: async ({ data }: Config) => {
    try {
      const res = await axios.post(urls.subscription.startFreeTrial(), data)
      return formatSuccessResponse(res)
    } catch (e) {
      throw formatErrorResponse(e)
    }
  },
  retrieveRuleExecutionDetails: async ({
    urlParams,
  }: ConfigWithURLParams): Promise<APIResponse<RuleExecutionDetails>> => {
    try {
      const res = await axios.get(
        urls.subscription.retrieveRuleExecutionDetails(
          urlParams.eventName.toString()
        )
      )
      return formatSuccessResponse(res)
    } catch (e) {
      throw formatErrorResponse(e)
    }
  },
}
